import axios from '_u/axios'

// 查询列表
export const cInfoList = (body) => {
    return axios.post('api/customer/info/list', body)
}

// 查看明细
export const cInfoView = (id) => {
    return axios.post('api/customer/info/view', { id })
}

// 新增客户
export const cInfoAdd = (body) => {
    return axios.post('api/customer/info/add', body)
}

// 修改客户
export const cInfoUpdate = (body) => {
    return axios.post('api/customer/info/update', body)
}

// 客户跟进管理
export const cTrackList = (body) => {
    return axios.post('api/customer/track/list', body)
}

// 新增跟进
export const cTrackAdd = (body) => {
    return axios.post('api/customer/track/add', body)
}

// 删除跟进
export const cTrackDel = (id) => {
    return axios.post('api/customer/track/delete', { id })
}

// 查询所有客户
export const cInfoListAll = () => {
    return axios.post('api/customer/info/listAll')
}

// 根据手机查客户是否存在
export const cusByIdentity = (body) => {
    // { phone: 'xxx' }
    return axios.post('api/customer/info/cusByIdentity', body)
}

// 客户查询,手机号前7位
export const queryCusSimple = (body) => {
    // { cusMobile: 'xxx' }
    return axios.post('api/customer/info/queryCusSimple', body)
}

export const queryCusSimpleVtwo = (body) => {
    // { cusName: 'xxx' }
    return axios.post('api/customer/info/queryCusSimpleVtwo', body)
}

// 获取租客上一次合同中录入的信息
export const getLastContractCus = (body) => {
    return axios.post('/api/contract/cus/getLastContractCus', body)
}
